import { NavLink } from 'fluxible-router';
import * as React from 'react';
import styles from './styles.module.styl';
export var GlossaryTermWidget = function (_a) {
    var title = _a.title, definition = _a.definition;
    return (React.createElement("div", { className: styles.widget },
        React.createElement(NavLink, { href: "/docs/glossary", className: styles.glossaryLink }, "Glossary"),
        React.createElement("h3", null, title),
        React.createElement("p", { dangerouslySetInnerHTML: { __html: definition } })));
};
